export default __webpack_public_path__ + "static/media/photo--sm--68.abe44276.jpg";